/**
 * Path relativo à pasta uploads (ex.: produtos/uuid.webp) para remover/enviar imagens da loja.
 * O backend grava em `uploads/<este path>` e a API de remoção espera o mesmo formato.
 */
export function getProdutoImageUploadPathFromUrl(url: string): string {
  if (!url) return "";
  const match = url.match(/\/uploads\/?(.*)$/);
  return (match?.[1] ?? url.split("/").pop() ?? url).replace(/^\/+/, "") || "";
}
